import React from "react"
import { Navigate, useLocation } from "react-router-dom"

interface IProps {
    children: React.ReactNode
    authorized: boolean
}

export const PublicRoute: React.FC<IProps> = ({ children, authorized }) => {
    const location = useLocation()

    if (!authorized) {
        return <>{children}</>
    }

    const from = (location.state as { from?: { pathname: string; search?: string; hash?: string } } | undefined)?.from
    if (from?.pathname) {
        return (
            <Navigate
                to={`${from.pathname}${from.search ?? ""}${from.hash ?? ""}`}
                replace
            />
        )
    }
    return <Navigate to="/" replace />
}
